import styled from 'styled-components';
import { userPanelElementStyles } from '../../../styles/sharedStyles';

export const StyledStudentsPaymentsElement = styled.div`
    ${userPanelElementStyles};
`;
